<div class="NetfirmFooter-container">
	<div class="NetfirmFooter-logo--container">
		<div class="NetfirmFooter-logo--image"></div>
	</div>
	<div class="NetfirmFooter-brand">
		<div class="NetfirmFooter-brand--text">
			&copy; {{'Netfirm.CiamLogin.CopyrightNotice' | translate: {currentYear: year} }}
		</div>
	</div>
	<div class="NetfirmFooter-selectButtonContainer" *ngIf="enableSelectButton">
		<div class="NetfirmFooter-dropdown">
			<button
				type="button"
				class="NetfirmFooter-dropdownBtn"
				(click)="toggleDropdown()"
				[attr.aria-haspopup]="true"
				[attr.aria-expanded]="isDropdownOpen"
				(keydown)="onKeydown($event)"
			>
				{{ selectedOption?.label || 'Select an option' }}
				<i class="NetfirmFooter--dropdownIcon" [class.open]="isDropdownOpen"></i>
			</button>
			<ul class="NetfirmFooter-dropdownMenu" #dropdownMenu *ngIf="isDropdownOpen" role="menu">
				<li
					*ngFor="let option of selectButtonOptions; let i = index"
					class="NetfirmFooter-dropdownMenu--item"
					role="menuitem"
					(keydown)="onKeydown($event, i)"
					(click)="selectOption(option)"
					tabindex="0"
				>
					{{ option.label }}
				</li>
			</ul>
		</div>
	</div>
</div>
